(function () {
  /* X-Timer */
  class XTimer extends HTMLElement {
    constructor() {
      super();

      this.end = this.getAttribute('end');
      this.dateFormat = this.getAttribute('date-format') || null;
      this.message = this.getAttribute('message');
      this.showDays = this.getAttribute('show-days') === 'true';
      this.parent = this.getAttribute('parent');
      this.separatorNominal = this.getAttribute('separator-nominal') === 'true';
      this.acumulateHours = this.getAttribute('acumulate-hours') === 'true';
    }
    connectedCallback() {
      this.run();
    }
    _parseDate(format = 'br') {
      const [date, time] = this.end.split(' ');

      switch (format) {
        case 'br':
          const [day, month, year] = date.split('/');
          const [hour, minute, second] = time.split(':');

          return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
      }
    }
    run() {
      /**
       * Timer format: yyyy-mm-ddTHH:mm:ssZ
       * Example: 2026-02-10T00:00:00Z (standard of the date & time for shopify field type)
       */
      const endAt = this.dateFormat ? this._parseDate(this.dateFormat) : this.end;
      const endTimestamp = new Date(endAt).getTime();

      const intervalTime = setInterval(() => {
        const now = new Date().getTime();
        const distance = endTimestamp - now;

        if (distance < 0) {
          if (this.parent) {
            const parent = this.closest(this.parent);

            parent ? parent.remove() : this.remove();
          } else {
            this.remove();
          }
          return clearInterval(intervalTime);
        }

        const _days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const _hours =
          Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) +
          (this.acumulateHours === true ? _days * 24 : 0);
        const _minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const _seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (typeof callback === 'function') {
          return callback(_days, _hours, _minutes, _seconds);
        }

        let response = '';

        const formatter = (value) => {
          const interedValue = parseInt(value);
          const quocient = parseInt(interedValue / 10);
          const modRest = parseInt(interedValue % 10);

          return `<span class="x-timer__value-part">${quocient}</span><span class="x-timer__value-part">${modRest}</span>`;
        };

        if (this.showDays === true && _days > 0) {
          response +=
            `<span class="x-timer__value" data-value="Dias">${formatter(('00' + _days).slice(-2))}</span>` +
            '<span class="x-timer__separator">d</span> ';
        }
        response +=
          `<span class="x-timer__value" data-value="Horas">${formatter(('00' + _hours).slice(-2))}</span>` +
          (this.separatorNominal ? '<span class="x-timer__separator">h</span> ' : ':');
        response +=
          `<span class="x-timer__value" data-value="Minutos">${formatter(('00' + _minutes).slice(-2))}</span>` +
          (this.separatorNominal ? '<span class="x-timer__separator">m</span> ' : ':');
        response +=
          `<span class="x-timer__value" data-value="Segundos">${formatter(('00' + _seconds).slice(-2))}</span>` +
          (this.separatorNominal ? '<span class="x-timer__separator">s</span>' : '');

        this.innerHTML = `${this.message || ''} ${response}`.trim();
      }, 1000);
    }
  }
  if (!window.customElements.get('x-timer')) {
    window.customElements.define('x-timer', XTimer);
  }
})();
